import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import styles from './CookieBanner.module.css';
import {useTranslation} from '../../hooks/useTranslation';

const STORAGE_KEY = 'ycm_cookie_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const t = useTranslation();

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) setVisible(true);
  }, []);

  const dismiss = (accepted) => {
    localStorage.setItem(STORAGE_KEY, accepted ? 'accepted' : 'declined');
    if (accepted) window.dispatchEvent(new CustomEvent('ycm:consent:accepted'));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className={styles.banner}
      role="dialog"
      aria-live="polite"
      aria-label={t.cookie.ariaLabel}
    >
      <div className={styles.inner}>
        <p className={styles.text}>
          {t.cookie.messageBefore}{' '}
          <Link to="/privacy" className={styles.link}>
            {t.cookie.policyLink}
          </Link>{' '}
          {t.cookie.messageAfter}
        </p>
        <div className={styles.actions}>
          <button
            className={`btn btn-primary ${styles.btnAccept}`}
            onClick={() => dismiss(true)}
          >
            {t.cookie.accept}
          </button>
          <button
            className={styles.btnDecline}
            onClick={() => dismiss(false)}
          >
            {t.cookie.decline}
          </button>
        </div>
      </div>
    </div>
  );
}
